import { render } from "./ListShields.vue?vue&type=template&id=1e928e29&lang=true"
import script from "./ListShields.vue?vue&type=script&lang=js"
export * from "./ListShields.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__